// 系统常量

// 需要登录访问的路由path
export const logpaths = [
  '/security',
  '/assets',
  '/borrow',
  '/invest',
  '/order',
  '/autobid',
  '/coupon',
  '/message/noticeList',
  '/invite',
  '/home'
]

// 需要显示认证提示的路由name
export const validwarn = [
  'borrowDetails',
  'borrow',
  'revolvingLoan',
  'domainManage',
  'registrarManage',
  'applyCredit',
  'recharge'
]
//需要提示弹窗得路由
export const notices = [
  'borrow',
  'invest',
  'assets'
]
// 借款周期
export const loandays = [{
    n: "7",
    v: 7,
    t: 'd'
  },
  {
    n: "15",
    v: 15,
    t: 'd'
  },
  {
    n: "1",
    v: 30,
    t: 'm'
  },
  {
    n: "2",
    v: 2 * 30,
    t: 'm'
  },
  {
    n: "3",
    v: 3 * 30,
    t: 'm'
  },
  {
    n: "4",
    v: 4 * 30,
    t: 'm'
  },
  {
    n: "5",
    v: 5 * 30,
    t: 'm'
  },
  {
    n: "6",
    v: 6 * 30,
    t: 'm'
  },
  {
    n: "7",
    v: 7 * 30,
    t: 'm'
  },
  {
    n: "8",
    v: 8 * 30,
    t: 'm'
  },
  {
    n: "9",
    v: 9 * 30,
    t: 'm'
  },
  {
    n: "10",
    v: 10 * 30,
    t: 'm'
  },
  {
    n: "11",
    v: 11 * 30,
    t: 'm'
  },
  {
    n: "12",
    v: 12 * 30,
    t: 'm'
  }
];
